/**
 * Which import slice an action targets, carried as `meta.source` and matched by the
 * `ui/import` reducers through `sourceMatcher`.
 *
 * `MODAL` is a value shared with `tireQuote` and `bodyScan` (both match `meta.source === 'modal'`)
 * and produced by the generic `openScanImportModal` saga, so it cannot be renamed here alone.
 */
export const IMPORT_SOURCE = {
  MODAL: 'modal',
} as const;

export type ImportSource = (typeof IMPORT_SOURCE)[keyof typeof IMPORT_SOURCE];
